import { SampleGroupExtended } from "../pharma/services";

export const hasAssociatedSamples = (sampleGroup: SampleGroupExtended) => {
    return sampleGroup.SamplesCreatedCount > 0 || sampleGroup.Sample?.length > 0;
}